export default __webpack_public_path__ + "static/media/31.a978e875.png";